import React, { useEffect, useState } from 'react';

const isTouchDevice = () => navigator.maxTouchPoints > 0;

export default function PdfViewer({ file }) {
  const [url, setUrl]     = useState(null);
  const [error, setError] = useState(false);
  const touch = isTouchDevice();

  const token = localStorage.getItem('kspro_token');
  const base  = file?._isPersonal ? '/api/personal-files' : '/api/project-files';
  const directUrl = file ? `${base}/${file._id}/download?token=${encodeURIComponent(token)}` : null;

  useEffect(() => {
    if (!file || touch) return;
    let active  = true;
    let blobUrl = null;
    fetch(`${base}/${file._id}/download`, { headers: { 'x-auth-token': token } })
      .then(res => { if (!res.ok) throw new Error(); return res.blob(); })
      .then(blob => {
        if (!active) return;
        blobUrl = URL.createObjectURL(blob);
        setUrl(blobUrl);
      })
      .catch(() => { if (active) setError(true); });
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [file?._id, touch]);

  if (error) return <div className="fm-loading">Failed to load PDF.</div>;

  // On touch devices open directly in the native browser PDF viewer
  if (touch) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 16, padding: 24 }}>
        <span style={{ fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' }}>
          {file?.filename}
        </span>
        <a
          href={directUrl}
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            padding: '10px 24px',
            background: 'var(--accent-light)',
            color: '#fff',
            borderRadius: 4,
            fontSize: 14,
            textDecoration: 'none',
            fontWeight: 500,
          }}
        >
          Open PDF
        </a>
      </div>
    );
  }

  if (!url) return <div className="fm-loading">Loading…</div>;

  return (
    <iframe
      src={`${url}#pagemode=none`}
      title={file.filename}
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
